import { render, staticRenderFns } from "./BackboneViewWrapper.vue?vue&type=template&id=4a41a769"
import script from "./BackboneViewWrapper.vue?vue&type=script&lang=js"
export * from "./BackboneViewWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports